export default "__VITE_ASSET__iLRlasdG__"